import React, { useEffect, useMemo } from 'react';

import { constants, SiteConfigManager, useBetslipState } from '@atlas/core';
import { BetOdds, Button, Label } from '@atlas/ui';

import { emptySelectedBet } from 'common/Betslip/BetslipClassic';
import { useNotificationsUIContext } from 'common/Popup/NotificationsUIContext';

import { useLocalBetslip } from './LocalBetslipContext';

const BetslipButtonNewNav = () => {
  const { selectedBetTypeIndex } = useLocalBetslip();
  const { betItems, betTypes, settings } = useBetslipState();
  const selectedBet = betTypes[selectedBetTypeIndex] || betItems[0] || emptySelectedBet;
  const { togglePopup } = useLocalBetslip();
  const { setIsFlyingBetslip } = useNotificationsUIContext();
  const isNewMobileNavigation = SiteConfigManager.getConfig(
    'config.config.general.newMobileNavigation',
  );
  const isFlyingBetslip = isNewMobileNavigation && betItems.length > 0;

  const selectedBetTypeComponent = useMemo(() => {
    if (selectedBet.betType === constants.BET_TYPE.SYSTEM) {
      return (
        <>
          <Label
            message="betslip_button_system"
            params={{
              winCombinationSize: selectedBet.winCombinationSize,
              outcomeAmount: selectedBet.outcomeAmount,
            }}
          />
          <span className="bet-type-count">
            ({`${selectedBet.winCombinationSize}/${selectedBet.outcomeAmount}`})
          </span>
        </>
      );
    }

    return (
      <span>
        <Label message={`betslip_button_${selectedBet.betType || 'single'}`} />
        {selectedBet.betType === constants.BET_TYPE.MULTIPLE && (
          <span className="bet-type-count">({betItems.length})</span>
        )}
        :
      </span>
    );
  }, [selectedBet]);

  const betslipMobileType = useMemo(() => {
    if (settings.mobileType === 'european') {
      return <Label message="betslip" />;
    }
    return (
      <>
        {selectedBetTypeComponent}
        {selectedBet.betType !== constants.BET_TYPE.SYSTEM && (
          <BetOdds className="odd-amount" odds={selectedBet.odds} />
        )}
      </>
    );
  }, [settings.mobileType, selectedBet]);

  useEffect(() => {
    setIsFlyingBetslip(isFlyingBetslip);
  }, [isFlyingBetslip]);

  if (!isFlyingBetslip) return null;

  return (
    <Button className="betslip-new-nav" onClick={togglePopup}>
      {betslipMobileType}
    </Button>
  );
};

export default BetslipButtonNewNav;
